module.exports = __webpack_public_path__ + "static/img/case_2.3a535631.jpg";